import { formsApiClient } from '../fetch/forms-api-client';

export interface GetUserPermissionsIds {
  apiToken: string,
  objectId: string,
  requestType: string,
}

const getUserPermissionsIds = async ({
  apiToken, objectId, requestType,
}: GetUserPermissionsIds) => {
  const fetchPermissions = async (type: string) => {
    const apiClient = formsApiClient(apiToken);
    const membershipPermissions = await apiClient.fetchMembershipPermissions(type, objectId);
    const extractIds = membershipPermissions.permissions
      .map((perm: any) => (requestType === 'userSelected' ? perm.id : perm.user_id));
    const mergedIds = extractIds.reduce((item: string, index: string) => item.concat(index), []);
    return mergedIds;
  };

  if (objectId) {
    if (requestType === 'userSelected') {
      const projectIds = await fetchPermissions('member_projects');
      const formIds = await fetchPermissions('member_forms');
      const result = { userAccessibleProjectIds: projectIds, userAccessibleFormIds: formIds };
      return result;
    }

    if (requestType === 'projectSelected') {
      const projectUserIds = await fetchPermissions('project_members');
      const result = { projectAccessibleUserIds: projectUserIds };
      return result;
    }
  }

  return null;
};

export default getUserPermissionsIds;
